import sm3 from 'sm-crypto'

export function sm3SignTokenParam(param) {
  const data = "app_id="+param.app_id+"&app_secret="+param.app_secret+"&code="+param.code+"&grant_type=authorization_code"+"&time="+param.time+"&uuid="+param.uuid
  console.log("sign data: "+data)
  return sm3.sm3(data)
}

export function sm3SignUserBaseInfo(param) {
  const data = "app_id="+param.app_id+"&app_secret="+param.app_secret+"&auth_token="+param.auth_token+"&time="+param.time+"&uuid="+param.uuid
  console.log("sign data: "+data)
  return sm3.sm3(data)
}